import { Link } from "react-router";
import { Logo } from "../logo";
import { t } from "@lingui/macro";
import { LocaleSwitch } from "@/client/components/locale-switch";
import { useLingui } from "@lingui/react";

export default function Footer() {
  const { i18n } = useLingui();

  return (
    <footer>
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        {/* Top area: Blocks */}
        <div className="grid gap-8 py-8 sm:grid-cols-12 md:py-12">
          {/* 1st block */}
          <div className="flex flex-col max-sm:order-1 sm:col-span-6 md:col-span-3 lg:col-span-4">
            <div className="mb-4">
              {/* Logo */}
              <Link className="flex h-8 w-8 items-center justify-center rounded-sm bg-white" to="/">
                <Logo />
              </Link>
            </div>
            <div className="grow text-sm text-zinc-500">
              &copy; cvkit.ai. {t`All rights received.`}
            </div>
            {/* Social links */}
            {/* <ul className="mt-4 mb-1 flex space-x-2">
              <li>
                <a
                  className="flex items-center justify-center text-zinc-400 transition hover:text-zinc-900"
                  href="#0"
                  aria-label="Twitter"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1.5em"
                    height="1.5em"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      color="currentColor"
                    >
                      <path d="M2.5 12c0-4.478 0-6.718 1.391-8.109S7.521 2.5 12.001 2.5c4.478 0 6.717 0 8.108 1.391S21.5 7.521 21.5 12c0 4.478 0 6.718-1.391 8.109S16.479 21.5 12 21.5c-4.478 0-6.717 0-8.109-1.391c-1.39-1.392-1.39-3.63-1.39-8.109"></path>
                      <path d="m7 17l4.194-4.193M17 7l-4.193 4.194m0 0L9.777 7H7l4.194 5.807m1.613-1.614L17 17h-2.778l-3.028-4.193"></path>
                    </g>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  className="flex items-center justify-center text-zinc-400 transition hover:text-zinc-900"
                  href="#0"
                  aria-label="Twitter"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1.5em"
                    height="1.5em"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      color="currentColor"
                    >
                      <path d="M7 10v7m4-4v4m0-4a3 3 0 1 1 6 0v4m-6-4v-3M7.008 7h-.009"></path>
                      <path d="M2.5 12c0-4.478 0-6.718 1.391-8.109S7.521 2.5 12 2.5c4.478 0 6.718 0 8.109 1.391S21.5 7.521 21.5 12c0 4.478 0 6.718-1.391 8.109S16.479 21.5 12 21.5c-4.478 0-6.718 0-8.109-1.391S2.5 16.479 2.5 12"></path>
                    </g>
                  </svg>
                </a>
              </li>
            </ul> */}
          </div>

          {/* 4th block */}
          <div className="flex items-center justify-end gap-6 sm:col-span-6 md:col-span-3 lg:col-span-6">
            <LocaleSwitch fullCountryName={true} />

            <a
              href="https://www.trustpilot.com/review/cvkit.ai"
              target="_blank"
              rel="noopener"
              className="rounded border border-[#00b67a] bg-white px-3 py-2 text-center"
            >
              <div className="flex items-center justify-center gap-2">
                <strong>{t`Review us on `}</strong>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1.6em"
                  height="1.6em"
                  viewBox="0 0 24 24"
                >
                  {/* Icon from Simple Icons by Simple Icons Collaborators - https://github.com/simple-icons/simple-icons/blob/develop/LICENSE.md */}
                  <path
                    fill="#00b67a"
                    d="m17.227 16.67l2.19 6.742l-7.413-5.388zM24 9.31h-9.165L12.005.589l-2.84 8.723L0 9.3l7.422 5.397l-2.84 8.714l7.422-5.388l4.583-3.326z"
                  />
                </svg>
                TrustPilot
              </div>
            </a>
          </div>

          <div className="flex items-center justify-center sm:col-span-6 md:col-span-3 lg:col-span-2">
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to={"/terms-and-conditions"}
                  className="text-zinc-500 transition hover:text-zinc-900"
                >
                  {t`Terms & Conditions`}
                </Link>
              </li>
              <li>
                <Link
                  to={"/privacy-policy"}
                  className="text-zinc-500 transition hover:text-zinc-900"
                >
                  {t`Privacy policy`}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
